import { createFileRoute } from "@tanstack/react-router";

import { AdminOrgs } from "@/features/admin";

/**
 * Admin > Organizzazioni — list route.
 *
 * Sibling to ``$orgId.tsx`` (detail). Previously this lived at
 * ``_modal/admin/orgs.tsx`` (file-only), which TanStack treated as the
 * PARENT route of ``orgs/$orgId.tsx``. Because ``AdminOrgs`` doesn't
 * render ``<Outlet/>``, the child detail route never mounted — the
 * "Apri dettaglio" kebab action navigated successfully but rendered
 * nothing. Moving the list into ``orgs/index.tsx`` makes list + detail
 * SIBLINGS under ``_modal/admin``, eliminating the silent dead-end.
 */
export const Route = createFileRoute("/_authed/_modal/admin/orgs/")({
  component: AdminOrgs,
});
